angular.module('shared').factory 'EnvironmentService', ->

  CwxEnvironment =
    Test: 'test'
    Development: 'development'
    Staging: 'staging'
    Uat: 'uat'
    Production: 'production'

  rawEnv = window.cwxEnv

  {
    environment: rawEnv
    isProductionEnv: -> rawEnv is CwxEnvironment.Production
  }
